
const BlogCard = ({ title, excerpt, date, category, onClick }) => {
  return (
    <article
      onClick={onClick}
      className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow cursor-pointer overflow-hidden group"
    >
      {/* Category Badge */}
      <div className="px-6 pt-4 pb-0">
        <span className="inline-block bg-blue-100 text-blue-800 text-xs font-semibold px-3 py-1 rounded-full mb-3">
          {category || 'Legal Article'}
        </span>
      </div>

      {/* Card Content */}
      <div className="px-6 pb-6">
        <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-blue-600 transition line-clamp-2">
          {title}
        </h3>
        <p className="text-gray-600 text-sm mb-4 line-clamp-3">{excerpt}</p>

        {/* Footer */}
        <div className="flex justify-between items-center pt-4 border-t border-gray-100">
          <span className="text-xs text-gray-500">{new Date(date).toLocaleDateString()}</span>
          <button
            type="button"
            onClick={() => onClick()}
            className="text-blue-600 font-semibold text-sm hover:text-blue-800 transition"
          >
            Read More →
          </button>
        </div>
      </div>
    </article>
  );
};

export default BlogCard;
